var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageNull(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.36142 19.7992H13.6414C18.0414 19.7992 19.8014 18.0392 19.8014 13.6392V8.35922C19.8014 3.95922 18.0414 2.19922 13.6414 2.19922H8.36142C3.96142 2.19922 2.20142 3.95922 2.20142 8.35922V13.6392C2.20142 18.0392 3.96142 19.7992 8.36142 19.7992Z",
    stroke: "#A4AAB2",
    strokeWidth: 1.32,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.36138 9.23875C9.3334 9.23875 10.1214 8.45077 10.1214 7.47875C10.1214 6.50673 9.3334 5.71875 8.36138 5.71875C7.38936 5.71875 6.60138 6.50673 6.60138 7.47875C6.60138 8.45077 7.38936 9.23875 8.36138 9.23875Z",
    stroke: "#A4AAB2",
    strokeWidth: 1.32,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.79102 17.1162L7.12942 14.2034C7.82462 13.737 8.82782 13.7898 9.45262 14.3266L9.74302 14.5818C10.4294 15.1714 11.5382 15.1714 12.2246 14.5818L15.8854 11.4402C16.5718 10.8506 17.6806 10.8506 18.367 11.4402L19.8014 12.6722",
    stroke: "#A4AAB2",
    strokeWidth: 1.32,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageNull);
export default __webpack_public_path__ + "static/media/image-null.67ad26d9e398d637ad25fa942f4ec989.svg";
export { ForwardRef as ReactComponent };